// Helper to load GSAP + ScrollTrigger from CDN if not present
(function loadGSAP(cb){
if(window.gsap && window.ScrollTrigger){ cb(); return; }
var core = document.createElement('script');
core.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
core.onload = function(){
var plug = document.createElement('script');
plug.src = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';
plug.onload = cb;
document.head.appendChild(plug);
};
document.head.appendChild(core);
})(function init(){
// Respect reduced motion
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if(reduce){
document.querySelectorAll('.ow-reveal').forEach(function(el){ el.style.opacity = 1; el.style.transform = 'none'; });
return;
}


gsap.registerPlugin(ScrollTrigger);


// 1) Enter reveal on load
gsap.to('.ow-reveal', {
opacity: 1,
y: 0,
duration: 0.9,
ease: 'power2.out',
stagger: 0.08,
delay: 0.05
});


// 2) Scroll-driven pin + parallax
var hero = document.querySelector('.ow-hero');
var centerImg = document.querySelector('.ow-center-figure img');
var rightImg = document.querySelector('.ow-right-figure img');
var leftCopy = document.querySelector('.ow-left');


var tl = gsap.timeline({
scrollTrigger: {
trigger: hero,
start: 'top top',
end: '+=120%',
scrub: 0.7,
pin: true,
anticipatePin: 1
}
});


// Scale + slight lift on the center image (Nectar)
tl.to(centerImg, { scale: 1.12, y: -20, ease: 'none' }, 0);
// Stronger parallax on right image (Mopo/R)
tl.to(rightImg, { y: -120, ease: 'none' }, 0);
// Counter‑parallax + focus on left copy
tl.to(leftCopy, { y: -30, ease: 'none' }, 0);


// 3) Optional: subtle glow accent as you scroll
tl.to(hero, { boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.04), inset 0 0 80px rgba(255,154,0,0.1)' }, 0.15);


// Make sure images are crisp after transforms
[centerImg, rightImg].forEach(function(img){
img.style.willChange = 'transform';
});
});